function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Position from '../../geomgraph/Position';
import Orientation from '../../algorithm/Orientation';
import Assert from '../../util/Assert';
var RightmostEdgeFinder = /*#__PURE__*/function () {
  function RightmostEdgeFinder() {
    _classCallCheck(this, RightmostEdgeFinder);
    RightmostEdgeFinder.constructor_.apply(this, arguments);
  }
  return _createClass(RightmostEdgeFinder, [{
    key: "getCoordinate",
    value: function getCoordinate() {
      return this._minCoord;
    }
  }, {
    key: "getRightmostSide",
    value: function getRightmostSide(de, index) {
      var side = this.getRightmostSideOfSegment(de, index);
      if (side < 0) side = this.getRightmostSideOfSegment(de, index - 1);
      if (side < 0) {
        this._minCoord = null;
        this.checkForRightmostCoordinate(de);
      }
      return side;
    }
  }, {
    key: "findRightmostEdgeAtVertex",
    value: function findRightmostEdgeAtVertex() {
      var pts = this._minDe.getEdge().getCoordinates();
      Assert.isTrue(this._minIndex > 0 && this._minIndex < pts.length, 'rightmost point expected to be interior vertex of edge');
      var pPrev = pts[this._minIndex - 1];
      var pNext = pts[this._minIndex + 1];
      var orientation = Orientation.index(this._minCoord, pNext, pPrev);
      var usePrev = false;
      if (pPrev.y < this._minCoord.y && pNext.y < this._minCoord.y && orientation === Orientation.COUNTERCLOCKWISE) {
        usePrev = true;
      } else if (pPrev.y > this._minCoord.y && pNext.y > this._minCoord.y && orientation === Orientation.CLOCKWISE) {
        usePrev = true;
      }
      if (usePrev) {
        this._minIndex = this._minIndex - 1;
      }
    }
  }, {
    key: "getRightmostSideOfSegment",
    value: function getRightmostSideOfSegment(de, i) {
      var e = de.getEdge();
      var coord = e.getCoordinates();
      if (i < 0 || i + 1 >= coord.length) return -1;
      if (coord[i].y === coord[i + 1].y) return -1;
      var pos = Position.LEFT;
      if (coord[i].y < coord[i + 1].y) pos = Position.RIGHT;
      return pos;
    }
  }, {
    key: "getEdge",
    value: function getEdge() {
      return this._orientedDe;
    }
  }, {
    key: "checkForRightmostCoordinate",
    value: function checkForRightmostCoordinate(de) {
      var coord = de.getEdge().getCoordinates();
      for (var i = 0; i < coord.length - 1; i++) {
        if (this._minCoord === null || coord[i].x > this._minCoord.x) {
          this._minDe = de;
          this._minIndex = i;
          this._minCoord = coord[i];
        }
      }
    }
  }, {
    key: "findRightmostEdgeAtNode",
    value: function findRightmostEdgeAtNode() {
      var node = this._minDe.getNode();
      var star = node.getEdges();
      this._minDe = star.getRightmostEdge();
      if (!this._minDe.isForward()) {
        this._minDe = this._minDe.getSym();
        this._minIndex = this._minDe.getEdge().getCoordinates().length - 1;
      }
    }
  }, {
    key: "findEdge",
    value: function findEdge(dirEdgeList) {
      for (var i = dirEdgeList.iterator(); i.hasNext();) {
        var de = i.next();
        if (!de.isForward()) continue;
        this.checkForRightmostCoordinate(de);
      }
      Assert.isTrue(this._minIndex !== 0 || this._minCoord.equals(this._minDe.getCoordinate()), 'inconsistency in rightmost processing');
      if (this._minIndex === 0) {
        this.findRightmostEdgeAtNode();
      } else {
        this.findRightmostEdgeAtVertex();
      }
      this._orientedDe = this._minDe;
      var rightmostSide = this.getRightmostSide(this._minDe, this._minIndex);
      if (rightmostSide === Position.LEFT) {
        this._orientedDe = this._minDe.getSym();
      }
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return RightmostEdgeFinder;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);
}();
export { RightmostEdgeFinder as default };
RightmostEdgeFinder.constructor_ = function () {
  this._minIndex = -1;
  this._minCoord = null;
  this._minDe = null;
  this._orientedDe = null;
};